//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'
import { getConfig, addFile } from '@/api/wx.js'
export default {
  props: ['obj', 'zoom', 'point'],
  data () {
    let self = this
    return {
      events: {
        init: (o) => {
          //   this.$refs.map.$amap.setFitView(12)
          //   this.$refs.map.$amap.setZoomAndCenter(9, this.po)
        },
        click: e => {
          this.$router.push({
            path: `/mamixiaowu/detail`,
            query: { id: e.target.getTitle() }
          })
        }
      },
      mapCenter: [120, 30],
      locallist: []
    }
  },
  methods: {
    // 微信权限配置
    wxconfig () {
      let ua = window.navigator.userAgent.toLowerCase()
      // alert('ua:' + ua)
      let href = window.location.href.split('#')[0]
      if (
        ua.match(/MicroMessenger/i) == 'micromessenger' &&
        ua.match(/wxwork/i) == 'wxwork'
      ) {
        href = window.location.href.split('#')[0]
        // alert('企业微信客户端')
      } else if (ua.match(/micromessenger/i) == 'micromessenger') {
        href = this.$store.state.user.wechatSignUrl
        // alert('微信客户端')
      }
      getConfig({
        url: href
      }).then(re => {
        var configs = re.returnValue
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: configs.appId, // 必填，公众号的唯一标识
          timestamp: configs.timestamp, // 必填，生成签名的时间戳
          nonceStr: configs.nonceStr, // 必填，生成签名的随机串
          signature: configs.signature, // 必填，签名，见附录1
          jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      })
    },
    getLocation () {
      wx.ready(() => {
        wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: (res) => {
            this.mapCenter = [res.longitude, res.latitude]
            console.log(this.mapCenter, 'wx.getLocation')
            this.$emit('getList', this.mapCenter)
          }
        })
      })
    }
  },
  computed: {
    markerss () {
      return this.obj
    },
    zo () {
      return this.zoom
    },
    po () {
      console.log(this.point, 'point')
      return this.point
    }
  },
  watch: {
    point: {
      handler (newVal, oldVal) {
        // 监听父组件传值，经纬度变化时，自动聚焦
        // this.$refs.map.$amap.setZoomAndCenter(9, newVal)
        if (newVal !== undefined) {
          if (newVal[0] !== 120 && newVal[1] !== 29) {
            this.$refs.map.$amap.setZoomAndCenter(9, newVal)
          } else {
            this.$refs.map.$amap.setZoomAndCenter(6, newVal)
          }
        } else {
          this.$refs.map.$amap.setZoomAndCenter(9, newVal)
        }
      },
      deep: true
    }
  },
  updated () {
    // this.getLocation()
  },
  mounted () {
    this.wxconfig()
    this.getLocation()
  }
}
